export const API_URL = "https://api.secondstage.app"
//export const API_URL = "http://localhost:8080"
//export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app"
export const TOOLPRESS_API = "https://toolpress-api.2ndstage.app"

export const THEME_CONFIG = {
    mode:"dark",
    gradients: {
        default: ['#E5057F', '#E5057F'],
        home_question: ['#E5057F', '#E5057F'],
        applausometro: ['#E5057F', '#E5057F'],
        siNo:['#3a4de4', '#00d8a1'],
        sentiment: ['#3a4de4', '#00d8a1'],
        wordcloud: ['#E5057F', '#E5057F'],
        qna: ['#E5057F', '#E5057F'],
    },
    primary: '#E5057F',
    secondary: '#263238',
    accent: '#E5057F',
    text: '#FFF',
    background:"#040f2d",
    poll:{
        default:"rgba(229,5,127,0.45)",
        answered:"#E5057F",
        correct: '#3A722D',
        wrong: '#DB0A16'
    }
}